import { render, staticRenderFns } from "./DefaultContainerPublic.vue?vue&type=template&id=3edd01ac&"
import script from "./DefaultContainerPublic.vue?vue&type=script&lang=js&"
export * from "./DefaultContainerPublic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DefaultContainerPublic.vue"
export default component.exports